import { render, staticRenderFns } from "./description-list.vue?vue&type=template&id=2be2fdb5&"
import script from "./description-list.vue?vue&type=script&lang=js&"
export * from "./description-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports